import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EventEntryState, PendingEventEntry } from './types';

export const initialEventEntryState: EventEntryState = {
  pending: null,
  enteringEventId: null,
};

export const eventEntrySlice = createSlice({
  name: 'eventEntry',
  initialState: initialEventEntryState,
  reducers: {
    setPendingEventEntry: (state, { payload }: PayloadAction<PendingEventEntry>) => {
      state.pending = payload;
    },
    clearPendingEventEntry: (state) => {
      state.pending = null;
    },
    setEnteringEvent: (state, { payload }: PayloadAction<number>) => {
      state.enteringEventId = payload;
    },
    clearEnteringEvent: (state) => {
      state.enteringEventId = null;
    },
  },
});

export const { setPendingEventEntry, clearPendingEventEntry, setEnteringEvent, clearEnteringEvent } =
  eventEntrySlice.actions;
